import PropTypes from "prop-types"

import FadeIn from "shared/components/fade_in"
import InfiniteFooter from "./infinite_footer"

import colors from "foundation/_colors_export.scss?export"

import styles from "./footer_button.module.scss"

export default function FooterButton({
  backgroundColor,
  disabled,
  label,
  onClick,
  fadeIn,
  fadeInDelay,
}) {
  if (backgroundColor === "darken") {
    backgroundColor = "rgba(0, 0, 0, 0.2)"
  } else if (backgroundColor === "lighten") {
    backgroundColor = "rgba(255, 255, 255, 0.15)"
  } else if (!backgroundColor) {
    backgroundColor = colors.quaternaryBackgroundColor
  }

  return (
    <FadeIn fade={fadeIn ? 500 : 0} delay={fadeInDelay || 0}>
      {/* extra div protects the button's own opacity */}
      <div>
        <button
          className={styles["button"]}
          type="submit"
          onClick={onClick}
          disabled={disabled}
          style={{ backgroundColor }}
        >
          {label}
        </button>
      </div>
      <InfiniteFooter
        backgroundColor={backgroundColor}
        opacity={disabled ? 0.4 : 1}
      />
    </FadeIn>
  )
}

FooterButton.propTypes = {
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  fadeIn: PropTypes.bool,
  fadeInDelay: PropTypes.number,
}

FooterButton.defaultProps = {
  fadeIn: false,
  fadeInDelay: 500,
}
